import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6beb3e7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Your todos:", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "styled-table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Urgent"),
    /*#__PURE__*/_createElementVNode("th", null, "Done"),
    /*#__PURE__*/_createElementVNode("th", null, "Created"),
    /*#__PURE__*/_createElementVNode("th", null, "Due"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString($setup.message) + " ", 1),
    ($setup.auth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_router_link, { to: { name: 'add' } }, {
            default: _withCtx(() => [
              _createTextVNode("Add todo")
            ]),
            _: 1
          }),
          ($setup.todo?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("table", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.todo, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'TodoViewSingle', params: {id: item.id} }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.is_urgent), 1),
                        _createElementVNode("td", null, _toDisplayString(item.is_done), 1),
                        _createElementVNode("td", {
                          textContent: _toDisplayString($options.getFormattedDateTime(item.creation_date))
                        }, null, 8, _hoisted_7),
                        _createElementVNode("td", {
                          textContent: _toDisplayString($options.getFormattedDateTime(item.due_date))
                        }, null, 8, _hoisted_8),
                        _createElementVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'TodoUpdateSingle', params: {id: item.id} }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Edit")
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'TodoDeleteSingle', params: {id: item.id} }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Delete")
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, "You have no Todos."))
        ]))
      : _createCommentVNode("", true)
  ]))
}